import React, { useContext, useEffect } from "react";
import "./Services.css";
import { themeContext } from "../../Context";
import Svg1 from "./Svg";

import Aos from "aos";
import 'aos/dist/aos.css';
// import Resume from './resume.pdf';



const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  useEffect(()=>{
    Aos.init({duration: 500 });
  }, []);

  
  return (

    <div className="services" id="services"data-aos-duration="5000" data-aos-delay="600"   >
      <span style={{ color: darkMode ? "white" : "" }} className='about_me anim' data-aos="flip-left"> All <span  data-aos="flip-left" className="me">About</span> Me</span>
      <div className="grid_about "  >
        <div className="awesome "  data-aos="slide-right" >
          <ul className='about_article anim'  >
            <li>
              Hello! My name Soumalya Ghoshal and I enjoy creating things that live on the internet.
            </li>
            <br />
            <li>I'm a passionate Developer, with strong administrative & communication skills, good attention to details & the ability to write efficient code.</li>
            <br />
            <li>I have clear, logical mind with a practical approach to problem-solving and a drive to see things through to completion.</li>
            <br />
            <li> I have work experience in multiple project and clone project with team collaboration.</li>
            <br />
            <li>Curious to Learn about emerging web technologies. Looking forward to working as an accountable and competent employee in an exciting tech company. After months of rigorous training, here I am looking for an opportunity as a full stack web developer.</li>
            <br />

          </ul>

        </div>


        <Svg1 className='svg' data-aos="slide-left" />
      </div>
    </div>

  );
};

export default Services;
